import React from 'react';
import styled from 'styled-components/macro';
/**
 *  Lista de checkbox que permite elegir entre varias opciones. Se utiliza en la pantalla
 * de estadísitcas para elegir entre distintos tipos de estadísticas.
 */

const CheckboxList = ({ atts, vars, elec }) => {
  const Boton = ({ tipo1, tipo2, title, color }) => {
    const selected = vars.vars[0] === tipo1 && JSON.stringify(vars.vars[1]) === JSON.stringify(tipo2)
    return (
      <BotonSelector
        selected={selected}
        onClick={() => {
          vars.funs[0](tipo1);
          vars.funs[1](tipo2);
        }}
        disabled={(elec === '7' && tipo2 === 'VP') || selected}

      >
        {vars.vars[0] === tipo1 && JSON.stringify(vars.vars[1]) === JSON.stringify(tipo2) ? (
          <>{title}</>
        ) : (
          <span>{title}</span>
        )}
      </BotonSelector>
    );
  };

  return (
    <section css="
      height:580px;
      display: flex;
      flex-direction: column;
      align-items:center;      
      overflow:auto"
    >
      {atts.lista.map(x => {
        return (
          <Lista key={x.titulo} color={atts.color}>
            <h4>{x.titulo}</h4>
            {x.lista.map((y, i) => {
              return (
                <div key={i}>
                  <Boton
                    tipo1={x.tipo}
                    tipo2={y.tipo}
                    title={y.nombre}
                    color={atts.color}
                  />
                </div>
              );
            })}
          </Lista>
        );
      })}
    </section>
  );
};

export default CheckboxList;


const Lista = styled.article`
  display: flex;
  flex-direction: column;
  gap:1.2rem;

  & h4 {
    font-size: 1.4rem;
    font-weight: 900;
    color: #164192;
    text-transform: uppercase;
    text-align:center;
  }
  & > div {
    margin: 0.75em 0;
    :hover {
      font-weight: bold;
    }
  }
  
`;

const BotonSelector = styled.button`
  display: flex;
  width: 300px;
  height: 42px;
  padding: 21px 34px;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
  border-radius: 100px;
  background: ${({ selected }) => (selected ? '#164192' : 'transparent')};
  color:${({ selected }) => (selected ? '#FFFFFF' : '#164192')};
  font-size: 16px;
  font-weight: 600;
  border: 2px solid #164192;
  white-space:nowrap; 

  &:hover{
    background: #164192;
    color:#FFFFFF;
  }

  &:disabled{
    cursor: not-allowed;
  }
`;
